import { getRolesGQLQuery, RoleFields } from '../../graphql/index.js'
import { QueryRolesArgs, Role } from '../../types/index.js'
import { GraphqlClient } from '../graphql.client.js'

export class RolesClient {
  private client: GraphqlClient

  constructor(client: GraphqlClient) {
    this.client = client
  }

  async list(
    variables: QueryRolesArgs,
    fields: RoleFields = 'basic',
    accessToken?: string,
  ): Promise<Array<Role>> {
    type QueryResult = { roles: Array<Role> }
    const result = await this.client.authorizedRequest<QueryResult>({
      query: getRolesGQLQuery(fields),
      variables,
      customToken: accessToken,
    })
    return result.roles
  }
}
